import { AnchorHTMLAttributes } from 'react';
import { Link, LinkProps } from 'react-router';
import { css } from '@emotion/react';

import { isInternalLink } from '../utils';
import { useHasRouter } from '../routing';
import { useBlockedClick } from '../navigation';

const resetStyles = css({
  outline: 'none',
  textDecoration: 'none',
  color: 'unset',
});

// Lint rules don't understand abstractions ...
/* eslint-disable jsx-a11y/anchor-has-content */

type AnchorProps = {
  // hrefs may conditionally be undefined, but the prop is mandatory so it cannot be forgotten
  href: string | undefined;
  enabled?: boolean;
} & Omit<LinkProps, 'to'> &
  Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href' | 'target' | 'rel'>;
const Anchor: React.FC<AnchorProps> = ({
  href,
  enabled = true,
  onClick,
  ...props
}) => {
  const blockedClick = useBlockedClick(onClick);
  const [internal, url] =
    enabled && href ? isInternalLink(href) : [false, undefined];
  if (useHasRouter() && url && internal) {
    return (
      <Link {...props} to={url} css={resetStyles} onClick={blockedClick} />
    );
  }
  return (
    <a
      {...props}
      href={(enabled && href) || undefined}
      target={internal ? undefined : '_blank'}
      rel={internal ? undefined : 'noreferrer noopener'}
      css={resetStyles}
      onClick={onClick}
    />
  );
};

export default Anchor;
